import { useEffect } from "react";
import { useSelector } from "react-redux";
import { ProductInstance } from "../utils/productClass";

export const useCategories = (refetch = false) => {
  const { categories, isLoading } = useSelector((state: any) => state.product);

  useEffect(() => {
    if (refetch || (!categories?.length && !isLoading)) {
      ProductInstance.getProductCategories();
    }
  }, [refetch]);

  return categories;
};
